import logoBlueLong from "../assets/brand/logos/AzulOscuroLargo.png";
import logoBlueMedium from "../assets/brand/logos/AzulOscuroMedio.webp";
import logoBlueShort from "../assets/brand/logos/AzulOscuroCorto.png";
import loginBackground from "../assets/brand/backgrounds/DG2.webp";
import loginBackgroundMobile from "../assets/brand/backgrounds/DG2Mobile.webp";
import { Link } from "react-router-dom";
import { ForgotUsernameForm } from "../components/auth/ForgotUsernameForm";
import { BrandButton } from "../components/ui/BrandButton";
import { useTrackedImagePreload } from "../hooks/useTrackedImagePreload";
import { TrackedImage } from "../components/ui/TrackedImage";

export function ForgotUsernamePage() {
  useTrackedImagePreload(loginBackground);
  useTrackedImagePreload(loginBackgroundMobile);
  return (
    <div
      className="auth-background min-h-screen overflow-hidden text-brand-primary"
      style={{
        "--auth-background-image": `url(${loginBackground})`,
        "--auth-background-mobile-image": `url(${loginBackgroundMobile})`,
      }}
    >
      <main className="flex min-h-screen w-full flex-col">
        <header className="flex items-start justify-start px-[40px] pt-[40px] sm:justify-between sm:px-[44px] sm:pt-[44px]">
          <TrackedImage
            src={logoBlueLong}
            alt="Penca OSU"
            className="h-[52px] w-auto object-contain sm:hidden"
          />
          <TrackedImage
            src={logoBlueMedium}
            alt="Penca OSU"
            className="hidden h-[52px] w-auto object-contain sm:block sm:h-[72px]"
          />
          <TrackedImage
            src={logoBlueShort}
            alt="Penca OSU"
            className="hidden h-[52px] w-auto object-contain sm:block sm:h-[72px]"
          />
        </header>

        <div className="flex flex-1 items-center justify-center px-4 py-6 sm:px-6 sm:py-10 lg:px-8 lg:py-8">
          <section className="w-full max-w-3xl">
            <div className="mb-4 flex justify-end">
              <BrandButton
                as={Link}
                to="/"
                preventScrollReset
                variant="outline"
                radius="xl"
                size="md"
                motion="subtle"
              >
                Volver al login
              </BrandButton>
            </div>
            <ForgotUsernameForm logoSrc={logoBlueLong} />
          </section>
        </div>
      </main>
    </div>
  );
}
